import React from "react";
import styled from "styled-components";
import Button from "components/common/Button";

const PublishBlock = styled.div`
  // background: green;  
  display: flex;
  margin-top: 1rem;
  margin-bottom: 3rem;
  button + button {
    margin-left: 0.5rem;
  }
`;

const StyledButton = styled(Button)`
  height: 2.125rem;
  & + & {
    margin-left: 0.5rem;
  }
`;

const PublishBox = ({ onPublish, onCancel }) => {
  return (
    <div className="PublishBox">
      <PublishBlock>
        <StyledButton color={"pink"} onClick={onPublish}>
          글쓰기
        </StyledButton>
        <StyledButton onClick={onCancel}>취소</StyledButton>
      </PublishBlock>
    </div>
  );
};

export default PublishBox;
